"use client";

import React, { Fragment } from "react";
import classNames from "classnames";
import { Popover, Transition } from "@headlessui/react";
import { XMarkIcon, Bars3Icon } from "@heroicons/react/24/outline";
import {
  ComponentNavigationNavbar,
  Enum_Componentnavigationnavbar_Variant,
  MenuItemEntity,
} from "../../../graphql/generated/graphql";
import { notEmpty } from "../../../utils/notEmpty";
import { NavbarItem } from "./NavbarItem";
import { NavbarMobileItem } from "./NavbarMobileItem";

function NavbarWithMenuItems({
  menu,
  navbarVariant = Enum_Componentnavigationnavbar_Variant.Default,
}: ComponentNavigationNavbar & {
  navbarVariant?: Enum_Componentnavigationnavbar_Variant;
}): JSX.Element {
  if (
    menu &&
    menu?.data?.attributes?.menuItems?.data &&
    menu?.data?.attributes?.menuItems?.data?.length <= 0
  ) {
    return <></>;
  }

  const items: MenuItemEntity[] =
    menu?.data?.attributes?.menuItems?.data
      .filter(notEmpty)
      .sort(
        (a, b) =>
          (a.attributes &&
            b.attributes &&
            a.attributes?.sort - b.attributes?.sort) ||
          0
      ) || [];

  if (items?.length === 0) {
    return <></>;
  }

  return (
    <>
      <div className="component-navbar">
        <Popover.Group className="">
          {/* xs Menu */}
          <Popover className="">
            <div className="md:hidden flex items-center">
              <Popover.Button className="rounded-md inline-flex items-center justify-center text-gray-900 hover:text-gray-500 focus:outline-none">
                <Bars3Icon className="h-6 w-6" />
              </Popover.Button>
              <Transition
                as={Fragment}
                appear={false}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Popover.Panel
                  focus
                  className="absolute bg-white z-10 top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
                >
                  <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                    <div className="pt-5 pb-6 px-5">
                      <div className="flex items-center justify-between">
                        <div></div>
                        <div className="-mr-2">
                          <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none">
                            <span className="sr-only">Close menu</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                          </Popover.Button>
                        </div>
                      </div>
                      <div className="flex flex-col gap-y-8 items-start">
                        {items.map((item) => (
                          <NavbarMobileItem key={item.id} item={item} />
                        ))}
                      </div>
                    </div>
                  </div>
                </Popover.Panel>
              </Transition>
            </div>
          </Popover>

          {/* md Menu */}
          <div
            className={classNames(
              "hidden md:flex md:gap-x-14 gap-y-2 h-full justify-start flex-wrap",
              {
                "md:gap-x-6":
                  navbarVariant ===
                  Enum_Componentnavigationnavbar_Variant.Dense,
                "md:gap-x-8":
                  navbarVariant ===
                  Enum_Componentnavigationnavbar_Variant.Default,
              }
            )}
          >
            {items.filter(notEmpty).map((item) => (
              <NavbarItem key={item.id} item={item} />
            ))}
          </div>
        </Popover.Group>
      </div>
    </>
  );
}

export { NavbarWithMenuItems };
